import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { Collapse, Typography, Icon, Divider } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

// HOC
import withRouter from '@/hoc/withRouter';

// COMPONENTS
import NavigationSkeleton from '@/components/Skeletons/NavigationSkeleton';

// HELP
import MenuItem from './help/MenuItem';
import BackToAdminMenuItem from './help/BackToAdminMenuItem';

// STYLES
import { ListStyled, ListItemStyled, CollapseIcon } from './styles';

export const CollapsableMenuItem = props => {
  const {
    data,
    router: { navigate },
  } = props;
  const { t } = useTranslation();
  const [open, setOpen] = useState(!!data.openByDefault);
  const hasRoute = !!data.route;

  const handleCollapse = e => {
    e.stopPropagation();

    setOpen(!open);
  };

  const handleMenuItemClick = e => {
    if (hasRoute) {
      navigate(data.route);
      return;
    }

    handleCollapse(e);
  };

  return (
    <>
      <ListItemStyled onClick={handleMenuItemClick}>
        {!!data.icon && <Icon className="m-r-10">{data.icon}</Icon>}
        <Typography variant="body2" className="cut-text">
          {t(data.label)}
        </Typography>
        <CollapseIcon onClick={handleCollapse}>
          {open ? <ExpandLess /> : <ExpandMore />}
        </CollapseIcon>
      </ListItemStyled>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {/* eslint-disable-next-line no-use-before-define */}
        <NavList {...props} data={data.submenu} nested />
      </Collapse>
    </>
  );
};

CollapsableMenuItem.propTypes = {
  router: PropTypes.object,
  data: PropTypes.object.isRequired,
};

export const NavList = props => {
  const { data, nested = false, loading = false } = props;

  if (loading) {
    return <NavigationSkeleton />;
  }

  return (
    <ListStyled className={`nav-list ${nested ? 'nav-list--nested' : ''}`} component="nav">
      {data.map((item, idx) => {
        if (item.type === 'divider') {
          return <Divider key={`${item.type}-${idx}`} />;
        }

        if (item.submenu && item.submenu.length) {
          return <CollapsableMenuItem {...props} data={item} key={item.route} />;
        }

        return <MenuItem data={item} key={item.route} />;
      })}
      {!nested && <BackToAdminMenuItem />}
    </ListStyled>
  );
};

NavList.propTypes = {
  nested: PropTypes.bool,
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};

const NavListComposed = compose(React.memo, withRouter)(NavList);

export default NavListComposed;
